import React, { useMemo } from 'react';
import styles from './UIGameBarbarianInvasionTrackerContainer.module.scss';
import { useBarbarianInvasionValidator } from '../../store/selectors/useBarbarianInvasionValidator.ts';
import { useKnightValidator } from '../../store/selectors/useKnightValidator.ts';
import { UIGameBarbarianInvasionTracker } from './UIGameBarbarianInvasionTracker.tsx';
import { MAX_BARBARIAN_PROGRESS } from '@colonist/game-states';
export const UIGameBarbarianInvasionTrackerContainer = ()=>{
    const barbarianInvasionValidator = useBarbarianInvasionValidator();
    const knightValidator = useKnightValidator();
    if (barbarianInvasionValidator == undefined || knightValidator == undefined) return null;
    const barbarianProgress = useMemo(()=>barbarianInvasionValidator.getBarbarianProgress(), [
        barbarianInvasionValidator
    ]);
    const barbarianStrength = useMemo(()=>barbarianInvasionValidator.getBarbarianStrength(), [
        barbarianInvasionValidator
    ]);
    const knightStrength = useMemo(()=>knightValidator.getTotalKnightStrength(), [
        knightValidator
    ]);
    const progressWhenBarbariansAttack = MAX_BARBARIAN_PROGRESS;
    return /*#__PURE__*/ React.createElement("div", {
        className: styles.barbarianInvasionTrackerContainer
    }, /*#__PURE__*/ React.createElement(UIGameBarbarianInvasionTracker, {
        barbarianProgress: barbarianProgress,
        barbarianStrength: barbarianStrength,
        knightStrength: knightStrength,
        progressWhenBarbariansAttack: progressWhenBarbariansAttack
    }));
};
